angular.module('cvsApp').service('healthCheckupService',['networkService', 'xdrService', 'healthCheckUpModel', 'configManager', 'cvsAppData', function (NS, XS, HCM, CM, CAD) {
   	
	function healthCheckupService (){	
		this.getHealthCheckup = function(callBackSuccess,tokenId){
			//get url


			var url = CM.getApiUrlWOQueryParams('GET_HEALTH_CHECKUP', "","", true);
			// url= 'https://fast.cvsspecialty.com/api/healthcheck';
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{
								"Content-Type":"application/xml"
							},

							onSuccess:callBackSuccess
						}
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, getRequestBody(tokenId), xdrSuccess);

					function xdrSuccess (data) {
						HCM.setHeaders(data.headers());
						callBackSuccess(HCM.getHeaders());
					}
				}
				else {
					var healthCheck = NS.get(request);
                    healthCheck.then(function(data, status, headers){
						HCM.setHeaders(data.headers());
						callBackSuccess(HCM.getHeaders());

						//send message to parent					
						//cvsUtility.sendPostMessage("SESSION-ALIVE","healthcheck");
						
					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});					
				}		
			}
							
		}


	}
	
	return new healthCheckupService();	
}]);
